import { styled, Box } from '@creditas-ui/react';

export const Wrapper = styled.div`
  max-width: 390px;
  margin: 0 auto;
`;
export const Form = styled.form`
  width: 100%;
  margin-top: 50px;
`;

export const LoginSection = styled(Box)`
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: 500px;
  padding: 0 70px;
`;

export const LoginLogoSection = styled.div`
  padding: 50px 0;

  img {
    width: 120px;
  }
`;
